import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle,
} from '@angular/material/dialog';
import {Stream} from '@app/stream/models';
import {
    UserPickerComponent,
    UserPickerComponent as UserPickerComponent_1
} from '@app/user-picker/user-picker/user-picker.component';

@Component({
    selector: 'frog-add-members-dialog',
    templateUrl: './add-members-dialog.component.html',
    styleUrls: ['./add-members-dialog.component.scss'],
    imports: [
        MatDialogTitle,
        MatDialogContent,
        UserPickerComponent_1,
        MatDialogActions,
        MatButton,
        MatDialogClose,
    ],
})
export class AddMembersDialogComponent implements OnInit {
    @ViewChild('picker') userPicker: UserPickerComponent;

    constructor(
        public dialogRef: MatDialogRef<AddMembersDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Stream,
    ) {}

    ngOnInit(): void {}

    accept() {
        this.dialogRef.close(this.userPicker.users);
    }
}
